var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row living-options"},[_c('card-tabs',{staticClass:"col-12 w-100",attrs:{"tabs":[
      { 
        label: 'Sessions',
        id: 'sessions',
      }, 
      { 
        label: 'Pages',
        id: 'pages',
      }
    ],"active-tab":_vm.activeTab},on:{"tabClick":_vm.navigateToTab},scopedSlots:_vm._u([{key:"sessions",fn:function(){return [_c('HeatmapsSessions')]},proxy:true},{key:"pages",fn:function(){return [_c('HeatmapsPages')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }